/**
* Testimonial JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonial component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'testimonial',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.testimonial' ).each( function() {
        if ( $( this ).find( '.testimonial-slide' ).length > 3 ) {
          $( this ).find( '.slider' ).slick( {
            dots: false,
            arrows: true,
            prevArrow: $( this ).find( '.prev-slide' )[0],
            nextArrow: $( this ).find( '.next-slide' )[0],
            slidesToShow: 3,
            centerMode: false,
            infinite: true,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                },
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                },
              },
            ],
          } );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonial', COMPONENT );
} )( app );
